import * as types from '../constants/ActionTypes';

const initialState = {
   drawerContainerScrollParams: {bookKey: null, scrollTop: 0}
};

export default function ctrl(state = initialState, action) {
   const {type, payload} = action;
   switch (type) {
      case types.SET_DRAWER_CONTAINER_SCROLL_PARAMS:
         return Object.assign({}, state, {
            drawerContainerScrollParams: payload.drawerContainerScrollParams
         });

      default:
         return state;
   }
}



// WEBPACK FOOTER //
// ./src/reducers/ctrl.js